import "../fcopel/style.css";
import { Sectionpd} from "../../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "../padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Fcopel() {
  return (
    <main>
        <Helmet>
            <title>Fundação Copel - Gabriel Barbosa</title>
            <meta name="description" content="Site principal sobre a Fundação Copel, maior entidade de fundo de pensão do sul do Brasil com o objetivo de garantir o pagamento de benefícios complementares à aposentadoria aos funcionários da COPEL (Cia Paranaense de Energia), COMPAGAS (Companhia Paranaense de Gás) e demais patrocinadores." />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/fcopel.jpg)'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>FUNDAÇÃO COPEL</h1>
                            <Flexmidbanner>
                                <a href="https://fcopel.org.br" target="_blank" rel="noreferrer">fcopel.org.br</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//FRONT-END + BANCO DE DADOS + WORDPRESS</Tags>
                            <Paragrafoint>Site principal sobre a Fundação Copel, maior entidade de fundo de pensão do sul do Brasil com o objetivo de garantir o pagamento de benefícios complementares à aposentadoria aos funcionários da COPEL (Cia Paranaense de Energia), COMPAGAS (Companhia Paranaense de Gás) e demais patrocinadores.</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/copel-site.png" alt="Home do site" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Participei ativamente da criação de um site, utilizando HTML, CSS, JavaScript e PHP para estruturar e implementar as funcionalidades. Além disso, integrei o WordPress como CMS, facilitando a manutenção e atualização de conteúdo pelo cliente de forma simples e intuitiva.
                                Fui responsável pelo desenvolvimento do mecanismo de busca, criação de páginas internas, elaboração de formulários de contato e contribui para a criação da lâmina de investimentos.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/gestor.png" alt="Página Canal do Gestor - Fcopel" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Participei ativamente da criação de um site, utilizando HTML, CSS, JavaScript e PHP para estruturar e implementar as funcionalidades. Além disso, integrei o WordPress como CMS, facilitando a manutenção e atualização de conteúdo pelo cliente de forma simples e intuitiva.
                                Fui responsável pelo desenvolvimento do mecanismo de busca, criação de páginas internas, elaboração de formulários de contato e contribui para a criação da lâmina de investimentos.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/sharknarguiles" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>Shark Narguiles</h3>
                                <span>//E-COMMERCE + BANCO DE DADOS + INTEGRAÇÃO</span>
                            </Btnnav>
                        </Link>
                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/sharknarguiles" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/energisaprev" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/energisaprev" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>EnergisaPrev</h3>
                                <span>//FRONT-END + WORDPRESS</span>
                            </Btnnav>
                        </Link>
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default Fcopel;